import * as React from "react";

import {
  InputGroup as ShadcnInputGroup,
  InputGroupAddon as ShadcnInputGroupAddon,
  InputGroupButton as ShadcnInputGroupButton,
  InputGroupText as ShadcnInputGroupText,
  InputGroupInput as ShadcnInputGroupInput,
  InputGroupTextarea as ShadcnInputGroupTextarea,
} from "src/shadcn/components/input-group";

const InputGroup = (props: React.ComponentProps<typeof ShadcnInputGroup>) => (
  <ShadcnInputGroup {...props} />
);

const InputGroupAddon = (
  props: React.ComponentProps<typeof ShadcnInputGroupAddon>
) => <ShadcnInputGroupAddon {...props} />;

const InputGroupButton = (
  props: React.ComponentProps<typeof ShadcnInputGroupButton>
) => <ShadcnInputGroupButton {...props} />;

const InputGroupText = (
  props: React.ComponentProps<typeof ShadcnInputGroupText>
) => <ShadcnInputGroupText {...props} />;

const InputGroupInput = React.forwardRef<
  React.ElementRef<typeof ShadcnInputGroupInput>,
  React.ComponentProps<typeof ShadcnInputGroupInput>
>((props, ref) => <ShadcnInputGroupInput ref={ref} {...props} />);

InputGroupInput.displayName = "InputGroupInput";

const InputGroupTextarea = React.forwardRef<
  React.ElementRef<typeof ShadcnInputGroupTextarea>,
  React.ComponentProps<typeof ShadcnInputGroupTextarea>
>((props, ref) => <ShadcnInputGroupTextarea ref={ref} {...props} />);

InputGroupTextarea.displayName = "InputGroupTextarea";

export {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupText,
  InputGroupInput,
  InputGroupTextarea,
};
